import type { ComponentProps } from "react";
import { cn } from "~/lib/utils";

/** Shared prompt surfaces; refs and data attributes stay on the same DOM nodes. */
export function ComposerFrame({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      {...props}
      data-chat-composer-main-surface="true"
      className={cn(
        "group relative z-10 rounded-[16px] p-px transition-colors duration-200",
        className,
      )}
    />
  );
}
export function ComposerSurface({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      {...props}
      data-chat-composer-surface="true"
      className={cn("rounded-[15px] transition-[background-color] duration-200", className)}
    />
  );
}

/** Geometry shared by chat and review prompts in resting and expanded states. */
export const COMPOSER_BODY_CLASS_NAME = "relative px-4 pb-2 pt-3.5 sm:pt-4";
export const COMPOSER_RESTING_BODY_CLASS_NAME = "py-2 sm:py-2";
export const COMPOSER_RESTING_EDITOR_CLASS_NAME =
  "max-h-8 min-h-8 overflow-hidden whitespace-nowrap! leading-8";
export const COMPOSER_RESTING_PLACEHOLDER_CLASS_NAME =
  "flex items-center overflow-hidden whitespace-nowrap leading-8";
export const COMPOSER_FOOTER_CLASS_NAME =
  "flex min-w-0 flex-nowrap items-center justify-between gap-2 overflow-visible px-2 pb-2";
export const COMPOSER_RESTING_FOOTER_CLASS_NAME =
  "absolute bottom-px right-px z-10 h-12 w-auto gap-0 py-0 sm:gap-0 sm:py-0";
export const COMPOSER_LEFT_CONTROLS_CLASS_NAME = "flex shrink-0 items-center gap-0";
